<template>
  <div class="viewer-toolbar">
    <div class="viewer-toolbar-title">
      <p>{{ fileName }}</p>
      <p>{{ mailFrom }}</p>
      <p class="mail-subject">{{ mailSubject }}</p>
      <p>{{ mailDate | formatDateFilter }}</p>
    </div>
    <div>
      <v-btn
        :disabled="currentPage === 1"
        icon
        small
        @click="$emit('page-change', currentPage - 1)"
      >
        <v-icon> chevron_left </v-icon>
      </v-btn>
      <span>
        Stran <br />
        {{ computedCurrentPage }} / {{ numberOfPages }}
      </span>
      <v-btn
        :disabled="currentPage === numberOfPages"
        icon
        small
        @click="$emit('page-change', currentPage + 1)"
      >
        <v-icon> chevron_right </v-icon>
      </v-btn>
      <VTooltip bottom>
        <v-btn slot="activator" icon @click="$emit('rotate')">
          <v-icon> rotate_right </v-icon>
        </v-btn>
        <span>Zasukaj</span>
      </VTooltip>
      <VTooltip bottom>
        <v-btn slot="activator" icon @click="$emit('refresh-canvas-size')">
          <v-icon> zoom_out_map </v-icon>
        </v-btn>
        <span>Povrni originalno velikost</span>
      </VTooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewControl',
  props: {
    fileName: {
      type: String,
      default: '',
    },
    mailFrom: {
      type: String,
      default: '',
    },
    mailSubject: {
      type: String,
      default: '',
    },
    mailDate: {
      type: String,
      default: '',
    },
    numberOfPages: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  filters: {
    formatDateFilter(date) {
      return new Date(date).toLocaleString('de-DE').replace(',', '');
    },
  },
  computed: {
    computedCurrentPage: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit('page-change', value);
      },
    },
  },
};
</script>

<style scoped>
.viewer-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
}
.viewer-toolbar div:nth-child(2) {
  display: flex;
  justify-content: right;
  align-items: center;
}

.viewer-toolbar-title {
  margin: 10px 20px;
}
.viewer-toolbar-title p {
  font-size: 12px;
  margin-bottom: 0px;
}
.mail-subject {
  font-weight: bold;
  font-size: 14px !important;
}
</style>
